import { emailArray } from "../components/services";
import React, { useState } from "react";
import routes from "../routes";
import { Link } from "gatsby";
import Hamburger from "hamburger-react";
import Logo1 from "../svgs/Logo1";
import MailIcon2 from "../svgs/MailIcon2";
import { palette } from "../styles/foundation";
import * as styles from "../styles/headerStyles";
import TelIcon from "../svgs/TelIcon";

// SP用のMenu
const SectionSpMenu = ({ isOpen }: { isOpen: boolean }) => {
  const ui = styles.uiSectionSpMenu;
  return (
    <ui.SpMenu id="spmenu" isOpen={isOpen} aria-hidden={isOpen ? undefined : true} role="menu">
      <ui.SpMenuList>
        <li>
          <ui.SpMenuLink to={routes.patientsPath()}>
            <span>患者様へご案内</span>
            <small>TO PATIENTS</small>
          </ui.SpMenuLink>
        </li>
        <li>
          <ui.SpMenuLink to={routes.professionalsPath()}>
            <span>医療関係者の方へ</span>
            <small>TO MEDICAL</small>
          </ui.SpMenuLink>
        </li>
        <li>
          <ui.SpMenuLink to={routes.aboutPath()}>
            <span>当科の紹介</span>
            <small>ABOUT US</small>
          </ui.SpMenuLink>
        </li>
        <li>
          <ui.SpMenuLink to={routes.networkPath()}>
            <span>未来への取り組み</span>
            <small>NCU HEART PROJECT</small>
          </ui.SpMenuLink>
        </li>
      </ui.SpMenuList>
      <ui.TelContainer>
        <ui.TelIconContainer>
          <TelIcon />
        </ui.TelIconContainer>
        <ui.Tel>
          <ui.TelLink href="tel:052-853-8077">052-853-8077</ui.TelLink>
          <ui.TelAnnotation>（名古屋市立大学大学院医学研究科：代表）</ui.TelAnnotation>
        </ui.Tel>
        <ui.Tel>
          <ui.TelLink href="tel:052-851-5511">052-851-5511</ui.TelLink>
          <ui.TelAnnotation>（名古屋市立大学病院：代表）</ui.TelAnnotation>
        </ui.Tel>
      </ui.TelContainer>
      <ui.MailContainer>
        <ui.MailIconContainer>
          <MailIcon2 />
        </ui.MailIconContainer>
        <ui.MailLink href={`mailto:${emailArray.join("")}`}>{emailArray.join("")}</ui.MailLink>
      </ui.MailContainer>
      <ui.Copyright>Copyright (C) NCU herz 2021</ui.Copyright>
    </ui.SpMenu>
  );
};

// PCのDrop down menu container
const DropDownMenu = ({ to, name, SubMenu }: { to: string; name: string; SubMenu: any }) => {
  const ui = styles.uiNavigation;
  let timeout: NodeJS.Timeout;
  const [active, setActive] = useState(false);

  const showTip = () => {
    clearInterval(timeout);
    setActive(true);
  };

  const hideTip = () => {
    timeout = setTimeout(() => {
      setActive(false);
    }, 150);
  };

  /*
   * MenuLinkにhoverするとSubMenuが開く
   * SubMenuは隙間をなくす目にWrapperを用意している
   * Enterするとactive stateがtrueになり、leaveするとfalseになる
   * MenuLinkとSubMenuContainerの両方でenter/leaveをとる
   */
  return (
    <ui.MenuLinkContainer aria-expanded={active ? true : false}>
      <ui.MenuLink to={to} onMouseEnter={showTip} onMouseLeave={hideTip} style={{ backgroundColor: active ? palette.red.dark : "", color: active ? "#FFF" : "" }}>
        {name}
      </ui.MenuLink>
      <ui.SubMenuContainer onMouseEnter={showTip} onMouseLeave={hideTip}>
        <SubMenu style={{ display: active ? "block" : "" }} active={active} />
      </ui.SubMenuContainer>
    </ui.MenuLinkContainer>
  );
};

// Drop down menu for 患者様へご案内 (PC only)
const DropDownMenuPatients = (props: any) => {
  const ui = styles.uiNavigation;
  return (
    <ui.Submenu {...props} aria-hidden={props.active ? undefined : true} role="menu">
      <li>
        <Link to={`${routes.patientsPath()}#differences`} role="menuitem">
          当科の特色
        </Link>
      </li>
      <li>
        <Link to={`${routes.patientsPath()}#consultation`} role="menuitem">
          外来受診
        </Link>
      </li>
      <li>
        <Link to={`${routes.patientsPath()}#operations`} role="menuitem">
          手術について
        </Link>
      </li>
      <li>
        <Link to={`${routes.patientsPath()}#diseases`} role="menuitem">
          主な疾患
        </Link>
      </li>
    </ui.Submenu>
  );
};

// Drop down menu for 当科の紹介 (PC only)
const DropDownMenuAbout = (props: any) => {
  const ui = styles.uiNavigation;
  return (
    <ui.Submenu {...props} role="menu">
      <li>
        <Link to={`${routes.aboutPath()}#greetings`} role="menuitem">
          教授挨拶
        </Link>
      </li>
      <li>
        <Link to={`${routes.aboutPath()}#introduction`} role="menuitem">
          スタッフ紹介
        </Link>
      </li>
      <li>
        <Link to={`${routes.aboutPath()}#results`} role="menuitem">
          手術実績
        </Link>
      </li>
      <li>
        <Link to={`${routes.aboutPath()}#entry`} role="menuitem">
          入局案内
        </Link>
      </li>
    </ui.Submenu>
  );
};

const Header = () => {
  const [isOpen, setOpen] = useState(false);
  const ui = styles.uiNavigation;
  return (
    <ui.Nav isOpen={isOpen}>
      <ui.Container>
        <ui.LogoLink to={routes.rootPath()}>
          <ui.LogoContainer>
            <Logo1 />
          </ui.LogoContainer>
          <ui.NameContainer>
            <ui.LabName>心臓血管外科学教室</ui.LabName>
            <ui.UnivName>NAGOYA CITY UNIVERSITY</ui.UnivName>
          </ui.NameContainer>
        </ui.LogoLink>
        <DropDownMenu to={routes.patientsPath()} name="患者様へご案内" SubMenu={DropDownMenuPatients} />
        <ui.MenuLinkContainer>
          <ui.MenuLink to={routes.professionalsPath()}>医療関係者の方へ</ui.MenuLink>
        </ui.MenuLinkContainer>
        <DropDownMenu to={routes.aboutPath()} name="当科の紹介" SubMenu={DropDownMenuAbout} />
        <ui.MenuLinkContainer>
          <ui.MenuLink to={routes.networkPath()}>
            NCU
            <br />
            HEART
            <br />
            PROJECT
          </ui.MenuLink>
        </ui.MenuLinkContainer>
        <ui.MenuIconContainer
          onClick={() => {
            setOpen(isOpen ? false : true);
          }}
          aria-label="メニューの開閉"
          aria-controls="spmenu"
        >
          <Hamburger color={palette.red.dark} distance="sm" size={30} toggled={isOpen} />
        </ui.MenuIconContainer>
      </ui.Container>
      <div style={{ position: "relative" }}>
        <SectionSpMenu isOpen={isOpen} />
      </div>
    </ui.Nav>
  );
};

export default Header;
